<template>
  <div class="box5">
    <pageTitle
      title="一课搞定国内外70%主流大模型"
      titleColor="#081745"
    />

    <div class="subject-content">
      
      <img src="../../../assets/coursePage/ai2/box5/img01.png"/>
      
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  mounted() {},
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.box5 {
  padding: 80px 0 0;
  width: 100%;
  background-image: url("../../../assets/coursePage/ai2/box5/bg01.png");
      background-repeat: no-repeat;
      background-size: cover;
  .subject-content {
    padding: 48px 48px 60px;
    img{
      width: 100%;
    }
    

    
  }
}
</style>
